import React from 'react';
import { X } from 'lucide-react';

/**
 * Generic workflow modal wrapper component
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the modal is visible
 * @param {Function} props.onClose - Close handler
 * @param {string} props.title - Modal title
 * @param {React.ReactNode} props.children - Modal content
 * @param {string} [props.headerColor='amber'] - Header gradient color (amber, blue, red, green, purple)
 * @param {string} [props.maxWidth='max-w-4xl'] - Max width class
 * @returns {JSX.Element|null}
 */
function WorkflowModal({
  isOpen,
  onClose,
  title,
  children,
  headerColor = 'amber',
  maxWidth = 'max-w-4xl'
}) {
  const headerGradients = {
    amber: 'from-amber-500 to-amber-600',
    blue: 'from-blue-500 to-blue-600',
    red: 'from-red-500 to-red-600',
    green: 'from-green-500 to-green-600',
    purple: 'from-purple-500 to-purple-600',
  };

  const headerGradient = headerGradients[headerColor] || headerGradients.amber;

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className={`bg-white rounded-lg shadow-xl ${maxWidth} w-full max-h-[90vh] overflow-hidden flex flex-col`}>
        {/* Header */}
        <div className={`bg-gradient-to-r ${headerGradient} text-white px-6 py-4 flex justify-between items-center`}>
          <h2 className="text-2xl font-bold">{title}</h2>
          <button onClick={onClose} className="text-white hover:text-gray-200">
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content container */}
        {children}
      </div>
    </div>
  );
}

export default WorkflowModal;
